<svelte:head>
    <meta name="description" content="StadiaDB is a game history and price tracker for Google's Stadia platform.">
    <title>StadiaDB</title>
</svelte:head>

<script>
    import Category from '../Category.svelte';
    import { Link } from 'svelte-routing';
    import { FirebaseApp, Doc, Collection } from 'sveltefire';
    import queryString from 'query-string';

    let parsed = {};

    if (typeof window !== 'undefined') {
        parsed = queryString.parse(window.location.search, {parseNumbers: true});
    }

    export let currency;
</script>

<Doc let:traceId path={'pages/home'} let:ref let:data={data} let:error>
    {#if data.note != ''}
    <div class="full-width notice">
        <p>{@html data.note}</p>
    </div>
    {/if}

    <div slot="fallback">
        <div class="full-width notice">
            <p><strong>Something went wrong</strong>, you're not supposed to see this.</p>
        </div>
    </div>
</Doc>

<Category type="new" {currency} title={'Just Released'} />
<Category type="sale" {currency} title={'On Sale'} />
<Category type="all" {currency} url={window.location.search} title={'All Games & Bundles'} />
<Category type="addons" {currency} url={window.location.search} title={'Add-ons'} />

<style>
    .notice {
        background: #eeeeee;
        padding: 10px;
        padding-left: 5vw;
        padding-right: 5vw;
        width: 90vw;
    }

    :global(main.dark) .notice {
        background: #212121;
    }
</style>